import { render, staticRenderFns } from "./UpdateWalletType.vue?vue&type=template&id=e00549f6"
import script from "./UpdateWalletType.vue?vue&type=script&lang=js"
export * from "./UpdateWalletType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports